// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"65164907","78":"577731ab","747":"ef3e60de","904":"96e808a1"}[chunkId] + ".chunk.js";
};